import React, { FC } from 'react'
import { useAdriverPixel } from 'Pages/landings/newLandings/common/hooks'
import { LandingNames } from 'Pages/landings/newLandings/common/constants'
import banner from './banner.png'
import bannerMobileWebp from './bannerMobile.webp'
import bannerMobileJpg from './bannerMobile.png'
import { Banner, TextBanner, TextTitle } from './styled'

export const BannerComponent: FC = () => {
	const containerRef = useAdriverPixel(LandingNames.RBO)
	return (
		<div ref={containerRef}>
			<Banner
				bannerMobileWebp={bannerMobileWebp}
				bannerMobileJpg={bannerMobileJpg}
				srcBanner={banner}
				subTitle={
					<TextTitle>
						Оформите заявку, без поездок в налоговую и откройте счет в банке с экономией для бизнеса
					</TextTitle>
				}
				buttonScrollTo="form"
				type="primary"
			>
				<TextBanner>
					Зарегистрируйте бизнес и&nbsp;откройте счет в&nbsp;Сбере за&nbsp;0 ₽
				</TextBanner>
			</Banner>
		</div>
	)
}
